const state = {
  campaigns: [],
  currentCampaign: {
    currentStageId: "",
    triggers: [],
    stages: [],
    fromTemplate: false,
    campaignId: "",
    name: "",
    emailId: null,
    description: null,
    fromName: null,
    active: false,
    address: {
      city: "",
      line1: "",
      line2: "",
      "postal-code": "",
      province: "",
      "street-direction": "",
      "street-name": "",
      "street-number": "",
      "unit-number": ""
    },
    createdAt: "",
    updatedAt: "",
    clients: [],
    emailVerified: false
  },
  automation: {},
  triggerMapper: {}
};
export default state;